import { render, staticRenderFns } from "./SpecialEvents.vue?vue&type=template&id=ed46cc6a&lang=pug&"
import script from "./SpecialEvents.vue?vue&type=script&lang=ts&"
export * from "./SpecialEvents.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports